import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppVersion = _resolveComponent("AppVersion")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view, {
      class: "view",
      onSetBackgroundColor: _ctx.setBackgroundColor
    }, null, 8, ["onSetBackgroundColor"]),
    _createVNode(_component_AppVersion)
  ], 64))
}